<template>
    <div class="modal fade" id="selectVariableModal" tabindex="-1" role="dialog" aria-labelledby="selectVariableModalTitle" aria-hidden="true" ref="modal">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="selectVariableModalTitle">Select variable</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div>
                        <div v-if="forecastVars.length != 0">
                            <h6 class="varListTitle">Forecast variables</h6>

                            <div class="list-group">
                                <button v-for="varItem in forecastVars"
                                        :key="'forecast_'+varItem.varID"
                                        type="button"
                                        class="list-group-item list-group-item-action"
                                        :class="{active : varItem.equals(selVar)}"
                                        data-varType="forecast"
                                        :data-varID="varItem.varID"
                                        @click="varItemClicked">{{ varItem.name }}</button>
                            </div>
                        </div>

                        <div v-if="historicalVars.length != 0">
                            <h6 class="varListTitle">Historical variables</h6>

                            <div class="list-group">
                                <button v-for="varItem in historicalVars"
                                        :key="'historical_'+varItem.varID"
                                        type="button"
                                        class="list-group-item list-group-item-action"
                                        :class="{ active: varItem.equals(selVar) }"
                                        data-varType="historical"
                                        :data-varID="varItem.varID"
                                        @click="varItemClicked">{{ varItem.name }}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="selectButtonClicked">Select</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>                
                </div>
            </div>
        </div>
    </div>    
</template>

<script>

import $ from '@/lib/JQuery.js'
import logger from '@/lib/logger.js'

export default {
    name: 'SelectVariableDialog',
    data() {
        return {
            selVar: null,
            mapViewer: null
        }
    },
    methods: {
        show(mapViewer) {
            this.mapViewer = mapViewer
            this.selVar = this.mapViewer.selVariable            
            $(this.$refs.modal).modal('show')
        },
        varItemClicked(e) {
            logger.log('SelectVariableDialog::varItemClicked')            
            let el = e.target            

            let varType = el.dataset.vartype
            let varID = el.dataset.varid

            logger.log('Searching for item type=' + varType + ', id=' + varID)            

            let item = this.$store.state.forecastVarInventory.find(varType, varID)

            logger.log('Found item', item)

            this.selVar = item
        },
        selectButtonClicked() {
            if (this.selVar == null)
                return
            
            this.mapViewer.selectVariable(this.selVar)
            $(this.$refs.modal).modal('hide')
        }        
    },
    computed: {
        forecastVars() {
            logger.log('SelectVariableDialog::forecastlVars')
            
            if (this.$store.state.forecastVarInventory == null)
                return []

            return this.$store.state.forecastVarInventory.forecastVars.items            
        },
        historicalVars() {
            logger.log('SelectVariableDialog::historicalVars')
            
            if (this.$store.state.forecastVarInventory == null)
                return []
                
            return this.$store.state.forecastVarInventory.historicalVars.items            
        }
    }
}
</script>

<style>
    .varListTitle {
        margin-top: 1em;
    }
</style>
